import { createSelector } from "reselect";

const getWeillCornell = (state) =>
  state?.variantResult?.weill_cornell_medicine_pmkb;
const getWustlCivic = (state) => state?.variantResult?.wustl_civic;
const getWustlDoCM = (state) => state?.variantResult?.wustl_docm;
const getJaxCkb = (state) => state?.variantResult?.jax_ckb;
const getPubMedArticlesFromStore = (state) =>
  state?.variantResult?.publications?.publications;

const displayCancerCurated = createSelector(
  getWeillCornell,
  getWustlCivic,
  getJaxCkb,
  (weilCornell, wustlCivic, jaxCkb, wustlDocm) => {
    return Boolean(weilCornell || wustlCivic || jaxCkb || wustlDocm);
  }
);

const getEvidenceCountPMKB = createSelector(getWeillCornell, (data) => {
  if (data && data.length > 0) {
    if (data[0].items.length > 0) {
      return data[0].items.length;
    }
  }
  return null;
});

const gettopEvidencePMKB = createSelector(getWeillCornell, (data) => {
  if (data && data.length > 0) {
    if (data[0].items.length > 0) {
      return data[0].items[0];
    }
  }
  return null;
});

export {
  getWeillCornell,
  getWustlCivic,
  getWustlDoCM,
  getJaxCkb,
  displayCancerCurated,
  getPubMedArticlesFromStore,
  getEvidenceCountPMKB,
  gettopEvidencePMKB,
};
